export function setBansLoading (state, loading = false) {
  state.bansLoading = loading
}

export function setBans (state, bans) {
  state.bans = bans.data
  state.bansCurrentPage = bans.current_page
  state.bansLastPage = bans.last_page
  state.bansPerPage = bans.per_page
  state.bansTotal = bans.total
}

export function setSearch (state, search = '') {
  state.search = search
}

export function setIndexPage (state, page = null) {
  state.indexPage = page
}
